import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { zhJson } from "./locales/zh";
import { enJson } from "./locales/en";
import Cookie from "project-config/utils/cookie";

i18n.use(initReactI18next).init({
  lng: Number(Cookie.getCookie("languageFlag")) === 0 ? "zh" : "en",
  debug: true,
  resources: {
    zh: zhJson,
    en: enJson,
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
